import { useDeferredLoading } from '~/hooks/useDeferredLoading';

type StatusTextProps = {
  failureText: string;
  hidden: boolean;
  loading: boolean;
  loadingText: string;
  success: boolean;
  successText: string;
};

export const colorStateClasses = {
  failure: 'text-red-700',
  loading: 'text-neutral-700',
  success: 'text-green-700',
};

export function StatusText({ failureText, hidden, loading, loadingText, success, successText }: StatusTextProps) {
  // Loading is considered slow if it takes longer than 500ms, so a quick load shows no status text
  const loadingSlowly = useDeferredLoading(loading, 500);
  const isHidden = hidden || (loading && !loadingSlowly);

  return (
    <div
      className={`relative overflow-hidden transition-all duration-300 ease-in-out motion-reduce:transition-none ${
        isHidden ? 'max-h-0 opacity-0' : 'max-h-24 opacity-100'
      }`}
      data-testid="status-text"
    >
      {loadingSlowly ? (
        // To prevent flashing, only show loading text after 500ms
        <p className={colorStateClasses.loading} data-testid="loading-text">
          {loadingText}
        </p>
      ) : (
        <p className={colorStateClasses[success ? 'success' : 'failure']}>{success ? successText : failureText}</p>
      )}
    </div>
  );
}
